(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["post-head-code-injector"] = factory();
	else
		root["post-head-code-injector"] = factory();
})(this, function() {
return 